module.exports = __webpack_public_path__ + "media/src/assets/Images/OpenTableArrow-8a914a5f806ffaba8ac8bde5f6139fb8.svg";